import { lazy, Suspense } from "react";
import "./App.css";
import AutherProvider from "./Context/AutherProvider/AutherProvider";
import SiteSettingProvider from "./Context/SiteSettingsProvider/SiteSettingsProvider";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { ToastContainer } from "./Components/StyledComponent/Toast";
import ToastProvider from "./Context/ToastProvider/ToastProvider";
import { renderLoader } from "./Constant/Loader";
import NoInternet from "./Components/StyledComponent/NoInternet";

const Main = lazy(() => import("./Pages/Main"));
const LoginPage = lazy(() => import("./Pages/Onboarding/LoginPage/LoginPage"));

function App() {
  return (
    <>
      <Suspense fallback={renderLoader()}>
        <ToastProvider>
          <ToastContainer />
          <AutherProvider>
             <SiteSettingProvider>
              <NoInternet /> 
              <BrowserRouter>
                <Routes>
                  <Route path="login" element={<LoginPage />} />
                  <Route path="/*" element={<Main />} />
                </Routes>
              </BrowserRouter>
             </SiteSettingProvider> 
          </AutherProvider>
        </ToastProvider>
      </Suspense>
    </>
  );
}

export default App;
